import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-data-teal text-white w-full py-16">
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop grid grid-cols-1 md:grid-cols-4 gap-gutter">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img src="/cafe-logo.webp" alt="CAFE" className="h-12 w-12 object-contain bg-white rounded-lg p-1" />
          </div>
          <p className="font-body-sm text-body-sm text-surface-variant opacity-80">
            Precision agrifood technology for the next generation of ecological growth.
          </p>
          <div className="bg-white p-2 rounded-lg inline-block">
            <img src="/IIT-Ropar-AWaDH.webp" alt="iHub-AWaDH IIT Ropar" className="h-10 object-contain" />
          </div>
        </div>
        <div>
          <h4 className="font-label-bold text-label-bold uppercase text-cucumber-blossom mb-4">Quick Links</h4>
          <nav className="flex flex-col gap-2">
            <Link to="/" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Home</Link>
            <Link to="/services" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Services</Link>
            <Link to="/research" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Research</Link>
            <Link to="/models" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">AI Models</Link>
          </nav>
        </div>
        <div>
          <h4 className="font-label-bold text-label-bold uppercase text-cucumber-blossom mb-4">Resources</h4>
          <nav className="flex flex-col gap-2">
            <a href="#" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Research Papers</a>
            <a href="#" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Seed Standards</a>
            <a href="#" className="font-body-sm text-body-sm text-surface-variant hover:text-white transition-colors">Privacy Policy</a>
          </nav>
        </div>
        <div>
          <h4 className="font-label-bold text-label-bold uppercase text-cucumber-blossom mb-4">Contact</h4>
          <p className="font-body-sm text-body-sm text-surface-variant opacity-80 mb-2">
            Chandji Wali Dhani, Ward No.1, Chomu, Jaipur, Rajasthan 303702
          </p>
          <a href="mailto:Chomucafe@gmail.com" className="font-body-sm text-body-sm text-surface-variant opacity-80 hover:text-white block mb-1">Chomucafe@gmail.com</a>
          <a href="tel:+917568279867" className="font-body-sm text-body-sm text-surface-variant opacity-80 hover:text-white block mb-3">+91 75682 79867</a>
          <div className="flex gap-4">
            <a href="mailto:Chomucafe@gmail.com"><span className="material-symbols-outlined opacity-60 hover:opacity-100 cursor-pointer">mail</span></a>
            <a href="tel:+917568279867"><span className="material-symbols-outlined opacity-60 hover:opacity-100 cursor-pointer">call</span></a>
          </div>
        </div>
      </div>
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop mt-16 pt-8 border-t border-white/10 text-center">
        <p className="font-body-sm text-body-sm text-surface-variant opacity-70">
          © 2026 CHOMU AgriFood Enterprises (CAFE) Private Limited. Supported by AWaDH, IIT Ropar.
        </p>
      </div>
    </footer>
  );
}
